/**
 * Creates a Stripe checkout session and redirects to the checkout page
 * @param {Object} params - Checkout parameters
 * @param {string} params.userId - User ID
 * @param {string} params.userEmail - User email
 * @param {boolean} [params.isYearly] - Whether to use yearly pricing
 * @param {string} [params.successUrl] - URL to redirect after successful payment
 * @param {string} [params.cancelUrl] - URL to redirect after cancelled payment
 * @returns {Promise<void>}
 */
export const redirectToStripeCheckout = async ({ userId, userEmail, isYearly = false, successUrl, cancelUrl }) => {
  const defaultSuccessUrl = `${window.location.origin}/dashboard?tab=billing&success=true`
  const defaultCancelUrl = `${window.location.origin}/pricing?canceled=true`

  const priceId = isYearly 
    ? import.meta.env.VITE_STRIPE_PRO_YEARLY_PRICE_ID 
    : import.meta.env.VITE_STRIPE_PRO_PRICE_ID

  const response = await fetch(import.meta.env.VITE_STRIPE_CHECKOUT_API_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      priceId,
      userId,
      userEmail,
      successUrl: successUrl || defaultSuccessUrl,
      cancelUrl: cancelUrl || defaultCancelUrl,
    }),
  })

  const data = await response.json()

  if (data.error) {
    throw new Error(data.error)
  }

  if (!data.url) {
    throw new Error('No checkout URL received')
  }

  window.location.href = data.url
}
